import type { Card } from '@/features/dashboard/api/schemas'
import {
  formatLike,
  toFigure,
  valueOptions,
  type FigureOptions,
} from '@/features/dashboard/format/figure'
import { formatChangeIn } from '@/features/dashboard/format/format'

/** A card's latest value and change, e.g. "€12.5M, +4% on the previous period". */
export const valueSummary = (
  card: Card,
  options?: FigureOptions
): string | null => {
  const figure = toFigure(card, options)
  if (!figure) return null
  const change =
    figure.change === null
      ? ''
      : `, ${formatChangeIn(figure.change, figure.changeUnit, valueOptions(figure))} on the previous period`
  return `${formatLike(figure, figure.value)}${change}`
}

/** A chart's text alternative: the card's name, latest value and change. */
export const chartSummary = (card: Card, options?: FigureOptions): string => {
  const summary = valueSummary(card, options)
  return summary === null ? card.name : `${card.name}: ${summary}`
}
